import { HostBinding, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { CorpoDirigenteService } from './shared/corpo-dirigente.service';

import { CorpoDirigente } from 'models/corpo-dirigente';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'corpo-dirigente',
  templateUrl: './corpo-dirigente.component.html',
  styleUrls: ['./corpo-dirigente.component.scss'],
  animations: [routerTransition],
})
export class CorpoDirigenteComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  environment = environment;
  corpoDirigenteObs: Observable<CorpoDirigente[]>;
  itensAcordeao: any[] = [];
  loading = false;

  constructor(
    private corpoDirigenteService: CorpoDirigenteService,
  ) { }

  ngOnInit(): void {
    this.buscarDirigentes();
  }

  buscarDirigentes(): void {

    this.loading = true;
    this.corpoDirigenteObs = this.corpoDirigenteService.query();
    this.corpoDirigenteObs.subscribe((dirigentes: CorpoDirigente[]) => {

      for (let i = 0; i < dirigentes.length; i++) {
        const dirigente: CorpoDirigente = dirigentes[i];

        this.itensAcordeao.push({
          id: i.toString(),
          titulo: dirigente.nome,
          subtitulo: dirigente.cargo,
          imageSRC: dirigente.getMedia() ? dirigente.getMedia().source_url : '/assets/images/profile.jpg',
          contexto: dirigente.sobre,
        });
      }

      this.loading = false;

    });

  }

}
